import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository, IStorageService } from '../../../domain/ports';
import type { UpdateProfileData, UserProfile } from '../../dto/dtos';

export class UpdateProfileUseCase implements IUseCase<UpdateProfileData, UserProfile> {
  constructor(
    private readonly authRepository: IAuthRepository,
    private readonly storageService: IStorageService,
  ) {}

  async execute(input: UpdateProfileData): Promise<UserProfile> {
    const response = await this.authRepository.updateProfile(input);

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Echec de la mise a jour');
    }

    this.storageService.setUser(response.data);
    return response.data;
  }
}
